import { render, staticRenderFns } from "./Game2048.vue?vue&type=template&id=3c99e62c&scoped=true&"
import script from "./Game2048.vue?vue&type=script&lang=js&"
export * from "./Game2048.vue?vue&type=script&lang=js&"
import style0 from "./Game2048.vue?vue&type=style&index=0&id=3c99e62c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c99e62c",
  null
  
)

export default component.exports